import { render, staticRenderFns } from "./WorkspaceItem.vue?vue&type=template&id=2cdad63e&scoped=true&"
import script from "./WorkspaceItem.vue?vue&type=script&lang=js&"
export * from "./WorkspaceItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceItem.scss?vue&type=style&index=0&id=2cdad63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdad63e",
  null
  
)

export default component.exports